import { render, staticRenderFns } from "./importTemplates.vue?vue&type=template&id=5f44735e"
import script from "./importTemplates.vue?vue&type=script&lang=js"
export * from "./importTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports